<template>
  <div class="match-recommend-content">
    <div class="inPlay fsbc">
      <div class="fc type-title">
        <img
          style="width: 20px; height: 20px"
          class="img-24 ml-8"
          :src="require('@/assets/home/ing.png')"
        />
        <span style="margin-left: 6px">{{ $t("pc.ing") }}</span>
      </div>
      <!--
      <div class="fc today-match" @click="toSchedule()">
        <span>今日比赛</span>
        <img class="img-16 ml-4" src="../../assets/img/home/share_arr_right.png" />
      </div>
			-->
    </div>
    <router-link
      :to="`/scheduleDetail/${item.match_id}/${item.sport_id}`"
      v-for="(item, index) in staringMatch"
      :key="item.home"
    >
      <div class="fsbc match-item-content inPlay-content">
        <div class="fc item-left">
          <img
            v-if="item.sport_id === 2"
            class="img-24 mr-16"
            :src="basketball"
          />
          <img v-else class="img-24 mr-16" :src="soccer" />
          <div class="fdsbc match-time">
            <span class="time">{{ getMatchTime(item.match_time, true) }}</span>
            <span class="date">{{ getMatchTime(item.match_time, false) }}</span>
          </div>

          <div
            class="match-name text-overflow-twoline"
            style="margin-left: 1rem"
          >
            {{ item.home }}
          </div>
          <img
            class="match-hometeam-logo"
            v-if="item.home_log"
            :src="item.home_log"
            :alt="$t('pc.loadingErr')"
          />
          <img
            class="match-hometeam-logo"
            v-else
            :src="
              item.sport_id == 2
                ? require('./img/match_logo_basketball.png')
                : require('./img/match_logo_football.png')
            "
            :alt="$t('pc.loadingErr')"
          />
        </div>
        <div class="fsbc item-right">
          <div class="fc">
            <div class="fsbc match-score">
              <div class="score">
                {{ item.home_score ? item.home_score : 0 }}
              </div>
              <div class="zbbf">
                <div class="zbbf-top">
                  {{ item.comp }}
                </div>
                <div class="score-bottom">
                  <!-- {{ item.match_detail_status }} -->
                  {{
                    item.sport_id === 1
                      ? $t(`fb_status.${item.raw_match_status}`)
                      : $t(`bb_status.${item.raw_match_status}`)
                  }}
                  {{ $t("pc.minuteNum", { num: item.time_playerd }) }}
                </div>
              </div>
              <div class="score">
                {{ item.away_score ? item.away_score : 0 }}
              </div>
            </div>
            <img
              class="match-hometeam-logo"
              v-if="item.away_log"
              :src="item.away_log"
              :alt="$t('pc.loadingErr')"
            />
            <img
              class="match-hometeam-logo"
              v-else
              :src="
                item.sport_id == 2
                  ? require('./img/match_logo_basketball.png')
                  : require('./img/match_logo_football.png')
              "
              :alt="$t('pc.loadingErr')"
            />
            <div class="match-name match-awayteam-name text-overflow-twoline">
              {{ item.away }}
            </div>
          </div>
          <div class="fdsbc match-btns">
            <!-- <div v-if="item.lives" class="more-anchors">
              <div>
                <img
                  v-for="anchor in item.lives"
                  :key="anchor.anchorid"
                  class="into-anchor img-24 pointer ml-8"
                  :src="anchor.logo"
                  alt="加载失败"
                  @click="enterRoom(anchor)"
                />
              </div>
              <router-link :to="`/liveMatchesTwo/${item.lives[0].anchorid}`" target="_blank" v-if="item.lives">
                <img class="img-24 ml-16 pointer" src="../../assets/img/home/match_shipin.png" />
              </router-link>
              <img class="img-16 ml-16" src="../../assets/img/home/share_arr_right.png" />
            </div> -->
            <div
              class="match-recommend-btn look-video flex-middle"
              @mouseover="isshowact = index"
              @mouseout="isshowact = null"
            >
              <img
                style="width: 0.14rem"
                v-show="isshowact !== index"
                :src="require('@/assets/live/playing.gif')"
              />
              <img
                style="width: 0.14rem"
                v-show="isshowact === index"
                src="./in-playing-white.gif"
              />
              {{ $t("pc.watchLiving") }}
            </div>
          </div>
        </div>
      </div>
    </router-link>

    <div class="no-data-img">
      <img
        v-show="staringMatch.length == 0"
        :src="require('@/assets/home/noData.png')"
        alt=""
      />
      <span>{{ $t("match.noData") }}</span>
    </div>

    <div class="inPlay not-start">
      <div class="fc type-title">
        <img
          style="width: 20px; height: 20px"
          class="img-24 ml-8"
          :src="require('@/assets/home/soon.png')"
        />
        <span style="margin-left: 6px">{{ $t("pc.matchWillBeStart") }}</span>
      </div>
    </div>

    <router-link
      :to="`/scheduleDetail/${item.match_id}/${item.sport_id}`"
      v-for="item in pendingMatch"
      :key="item.home"
    >
      <div class="fsbc match-item-content inPlay-content">
        <div class="fc item-left not-start-left">
          <img
            v-if="item.sport_id === 2"
            class="img-24 mr-16"
            :src="basketball"
          />
          <img v-else class="img-24 mr-16" :src="soccer" />
          <div class="fdsbc match-time">
            <span class="time">{{ getMatchTime(item.match_time, true) }}</span>
            <span class="date">{{ getMatchTime(item.match_time, false) }}</span>
          </div>

          <!-- <div class="fcc match-desc text-overflow-twoline"  >
            <span>{{ item.comp }}</span>
          </div> -->
          <!-- <div class="match-status">{{ item.match_detail_status }}</div> -->
          <div
            class="match-name text-overflow-twoline"
            style="margin-left: 1rem"
          >
            {{ item.home }}
          </div>
          <img
            class="match-hometeam-logo"
            v-if="item.home_log"
            :src="item.home_log"
            :alt="$t('pc.loadingErr')"
          />
          <img
            class="match-hometeam-logo"
            v-else
            :src="
              item.sport_id == 2
                ? require('./img/match_logo_basketball.png')
                : require('./img/match_logo_football.png')
            "
            :alt="$t('pc.loadingErr')"
          />
        </div>
        <div class="fsbc item-right">
          <div class="fc">
            <div class="fsbc match-score">
              <div class="score">
                {{ item.home_score ? item.home_score : "-" }}
              </div>
              <div class="zbbf">
                <div class="zbbf-top">
                  {{ item.comp }}
                </div>
                <div class="score-bottom">
                  <!-- {{ item.match_detail_status }} -->
                  {{
                    item.sport_id === 1
                      ? $t(`fb_status.${item.raw_match_status}`)
                      : $t(`bb_status.${item.raw_match_status}`)
                  }}
                </div>
              </div>
              <div class="score">
                {{ item.away_score ? item.away_score : "-" }}
              </div>
            </div>
            <img
              class="match-hometeam-logo"
              v-if="item.away_log"
              :src="item.away_log"
              :alt="$t('pc.loadingErr')"
            />
            <img
              class="match-hometeam-logo"
              v-else
              :src="
                item.sport_id == 2
                  ? require('./img/match_logo_basketball.png')
                  : require('./img/match_logo_football.png')
              "
              :alt="$t('pc.loadingErr')"
            />
            <div class="match-name match-awayteam-name text-overflow-twoline">
              {{ item.away }}
            </div>
          </div>
          <div
            class="fdsbc match-btns"
            @mouseover="isshowact = index"
            @mouseout="isshowact = null"
          >
            <!-- <img class="img-16 ml-16" src="../../assets/img/home/share_arr_right.png" /> -->
            <div class="match-recommend-btn match-end-btn look-video no-play">
              {{ $t("common.unStart") }}
            </div>
          </div>
        </div>
      </div>
    </router-link>

    <div class="no-data-img">
      <img
        v-show="pendingMatch.length == 0"
        :src="require('@/assets/home/noData.png')"
        alt=""
      />
      <span>{{ $t("match.noData") }}</span>
    </div>

    <!-- <div class="inPlay not-start">
      <div class="fc type-title">
        <span>待开赛</span>
        <img class="img-24 ml-8" src="./game2.png" />
      </div>
    </div>

    <router-link :to="`/scheduleDetail/${item.match_id}/${item.sport_id}`" v-for="item in pendingMatch" :key="item.home">
      <div class="fsbc match-item-content inPlay-content">
        <div class="fc item-left not-start-left">
           <img v-if="item.sport_id === 2" class="img-24 mr-16" :src="basketball" />
          <img v-else class="img-24 mr-16" :src="soccer" />
          <div class="fdsbc match-time">
            <span class="time">{{ getMatchTime(item.match_time, true) }}</span>
            <span class="date">{{ getMatchTime(item.match_time, false) }}</span>
          </div>
          <div class="match-name text-overflow-twoline" style="margin-left: 1rem;">{{ item.home }}</div>
          <img class="match-hometeam-logo" v-if="item.home_log" :src="item.home_log" alt="加载失败" />
          <img
            class="match-hometeam-logo"
            v-else
            :src="item.sport_id == 2 ? require('./img/match_logo_basketball.png') : require('./img/match_logo_football.png')"
            alt="加载失败"
          />
        </div>
        <div class="fsbc item-right">
          <div class="fc">
          <div class="zbbf">
                   <div class="zbbf-top">
                      {{ item.comp }}
                    </div>
                    <div class="score-bottom">{{ item.match_detail_status }}</div>
              </div>
            <img class="match-hometeam-logo" v-if="item.away_log" :src="item.away_log" alt="加载失败" />
            <img
              class="match-hometeam-logo"
              v-else
              :src="item.sport_id == 2 ? require('./img/match_logo_basketball.png') : require('./img/match_logo_football.png')"
              alt="加载失败"
            />
            <div class="match-name match-awayteam-name text-overflow-twoline">{{ item.away }}</div>
          </div>
          <div class="fdsbc match-btns">
            <div class="match-recommend-btn match-order-btn">预约</div>
          </div>
        </div>
      </div>
    </router-link> -->

    <div class="inPlay not-start">
      <div class="fc type-title">
        <img
          style="width: 20px; height: 20px"
          class="img-24 ml-8"
          :src="require('@/assets/home/end.png')"
        />
        <span style="margin-left: 6px">{{ $t("common.end") }}</span>
      </div>
    </div>

    <router-link
      :to="`/scheduleDetail/${item.match_id}/${item.sport_id}`"
      v-for="item in finishedMatch"
      :key="item.home"
    >
      <div class="fsbc match-item-content inPlay-content">
        <div class="fc item-left not-start-left">
          <img
            v-if="item.sport_id === 2"
            class="img-24 mr-16"
            :src="basketball"
          />
          <img v-else class="img-24 mr-16" :src="soccer" />
          <div class="fdsbc match-time">
            <span class="time">{{ getMatchTime(item.match_time, true) }}</span>
            <span class="date">{{ getMatchTime(item.match_time, false) }}</span>
          </div>

          <!-- <div class="fcc match-desc text-overflow-twoline">
            <span>{{ item.comp }}</span>
          </div>
          <div class="match-status">{{ item.match_detail_status }}</div> -->
          <div
            class="match-name text-overflow-twoline"
            style="margin-left: 1rem"
          >
            {{ item.home }}
          </div>
          <img
            class="match-hometeam-logo"
            v-if="item.home_log"
            :src="item.home_log"
            :alt="$t('pc.loadingErr')"
          />
          <img
            class="match-hometeam-logo"
            v-else
            :src="
              item.sport_id == 2
                ? require('./img/match_logo_basketball.png')
                : require('./img/match_logo_football.png')
            "
            :alt="$t('pc.loadingErr')"
          />
        </div>
        <div class="fsbc item-right">
          <div class="fc">
            <div class="fsbc match-score">
              <div class="score">
                {{ item.home_score ? item.home_score : 0 }}
              </div>
              <div class="zbbf">
                <div class="zbbf-top">
                  {{ item.comp }}
                </div>
                <div class="score-bottom">
                  <!-- {{ item.match_detail_status }} -->
                  {{
                    item.sport_id === 1
                      ? $t(`fb_status.${item.raw_match_status}`)
                      : $t(`bb_status.${item.raw_match_status}`)
                  }}
                </div>
              </div>
              <div class="score">
                {{ item.away_score ? item.away_score : 0 }}
              </div>
            </div>
            <img
              class="match-hometeam-logo"
              v-if="item.away_log"
              :src="item.away_log"
              :alt="$t('pc.loadingErr')"
            />
            <img
              class="match-hometeam-logo"
              v-else
              :src="
                item.sport_id == 2
                  ? require('./img/match_logo_basketball.png')
                  : require('./img/match_logo_football.png')
              "
              :alt="$t('pc.loadingErr')"
            />
            <div class="match-name match-awayteam-name text-overflow-twoline">
              {{ item.away }}
            </div>
          </div>
          <div class="fdsbc match-btns">
            <!-- <img class="img-16 ml-16" src="../../assets/img/home/share_arr_right.png" /> -->
            <div class="match-recommend-btn match-end-btn">
              {{ $t("common.end") }}
            </div>
          </div>
        </div>
      </div>
    </router-link>

    <div class="no-data-img">
      <img
        v-show="finishedMatch.length == 0"
        :src="require('@/assets/home/noData.png')"
        alt=""
      />
      <span>{{ $t("match.noData") }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    pendingMatch: {
      type: Array,
      default() {
        return [];
      },
    },
    staringMatch: {
      type: Array,
      default() {
        return [];
      },
    },
    finishedMatch: {
      type: Array,
      default() {
        return [];
      },
    },
    soondMatch: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      isshowact: null,
    };
  },
  mounted() {},
  computed: {
    basketball() {
      return require("@/assets/live/basketball.png");
    },
    soccer() {
      return require("@/assets/live/football.png");
    },
  },
  methods: {
    getMatchTime(time, type) {
      const date = new Date(time * 1000);
      const MM = date.getMonth() + 1;
      const DD = date.getDate();
      const hh = date.getHours();
      const mm = date.getMinutes();
      if (type) {
        return `${hh < 10 ? "0" + hh : hh}:${mm < 10 ? "0" + mm : mm}`;
      } else {
        return `${MM < 10 ? "0" + MM : MM}-${DD < 10 ? "0" + DD : DD}`;
      }
    },
    enterRoom(live) {
      this.$router.push({
        path: `/liveMatchesTwo/${live.anchorid}`,
      });
    },
    toSchedule() {
      this.$router.push("/schedule");
    },
  },
};
</script>
<style lang="scss" scoped>
.fsbc {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.fcc {
  // display: flex;
  justify-content: center;
  align-items: center;
}

.fc {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.fdsbc {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.ml-4 {
  margin-left: 4px;
}

.ml-8 {
  margin-left: 8px;
}

.ml-16 {
  margin-left: 16px;
}

.mr-16 {
  margin-right: 16px;
}

.img-48 {
  width: 48px;
  height: 48px;
}

.img-24 {
  width: 24px;
  height: 24px;
}

.img-16 {
  width: 16px;
  height: 16px;
}

.pointer {
  cursor: pointer;
}

.match-recommend-content {
  width: 100%;
  background: #ffffff;
  border-radius: 0.1rem;
  margin-bottom: 0.32rem;

  .inPlay {
    width: 100%;
    height: 0.48rem;
    padding: 0.12rem 0.24rem;
    background: #f0f0f0;
  }

  .not-start {
    background: #f0f0f0;
  }

  .type-title {
    font-size: 14px;
    color: #999999;
    letter-spacing: 0;
    font-weight: 400;
  }

  .today-match {
    font-size: 0.14rem;
    line-height: 0.24rem;
    color: #999999;
    justify-content: flex-end;
    cursor: pointer;
  }

  .match-item-content {
    width: 100%;
    height: 0.96rem;
  }

  .item-left {
    // width: 604px;
    height: 0.96rem;
    padding-left: 0.24rem;
    // padding-right: 0.15rem;
  }

  .match-time {
    width: 0.97rem;
    margin-right: 0.07rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .time {
      font-size: 0.2rem;
      color: #333333;
      letter-spacing: 0;
      font-weight: 700;
      margin-bottom: 0.05rem;
    }
    .date {
      font-size: 0.12rem;
      color: #999999;
    }
  }

  .match-desc {
    width: 2rem;
    font-size: 0.14rem;
    line-height: 0.2rem;
    color: #666666;
    // margin-right: 1.02rem;
    // display: flex;
    justify-content: flex-start;
  }
  .match-status {
    width: 1rem;
    text-align: center;
  }

  .match-name {
    width: 1.6rem;
    font-size: 0.16rem;
    color: #333333;
    letter-spacing: 0;
    text-align: right;
    font-weight: 500;
    margin-right: 0.16rem;
  }

  .match-hometeam-logo {
    width: 0.52rem;
    height: 0.52rem;
  }

  .item-right {
    flex: 1;
    height: 0.96rem;
    padding-right: 0.24rem;
  }

  .match-score {
    // width: 0.96rem;
    font-size: 0.28rem;
    color: #333333;
    letter-spacing: 0;
    font-weight: 500;
    // margin-right: 0.15rem;
    margin: 0rem 0.3rem;

    .score {
      width: 0.8rem;
      text-align: center;
    }
  }

  .match-vs {
    width: 0.96rem;
    font-size: 0.2rem;
    color: #333;
    letter-spacing: 0;
    text-align: center;
    font-weight: 500;
    margin-right: 0.15rem;
  }

  .match-awayteam-name {
    text-align: left;
    margin-left: 0.16rem;
  }

  .more-anchors {
    height: 0.24rem;
    justify-content: flex-end;
    text-align: right;
    margin-bottom: 0.1rem;
  }

  .into-anchor {
    border-radius: 50%;
  }

  .match-btns {
    align-items: flex-end;
  }

  .match-recommend-btn {
    width: 1.42rem;
    line-height: 0.42rem;
    text-align: center;
    font-size: 0.16rem;
    font-weight: 500;
    // background: linear-gradient(90deg, #29f19c 0%, #02a1f9 100%);
    background: #ffffff;
    border-radius: 0.06rem;
    border: 1px solid rgba(208, 45, 84, 1);
  }

  .look-video {
    color: rgba(208, 45, 84, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      margin-right: 7.5px;
    }
  }

  .look-video:hover {
    color: #ffffff;
    background: rgba(208, 45, 84, 1) !important;
    border: none !important;
  }
  .match-end-btn {
    color: #999;
    background: #f0f0f0;
    border: 1px solid #dbdbdb;
  }

  .match-end-btn:hover {
    color: #888888;
    background: #f0f0f0;
    border: 1px solid #aaaaaa;
    box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.15);
  }

  .inPlay-content {
    background-image: linear-gradient(
      270deg,
      #ffffff 0%,
      #ffffff 67.08%,
      #ffe4e4 103.96%
    );
    background-size: 100% 100%;
    .item-left {
      background-size: 100% 100%;
    }

    .not-start-left {
      background: #ffffff;
      border-radius: 0 !important;
    }

    &:last-child .not-start-left {
      border-radius: 0 0 0 16px;
    }

    &:hover {
      background: rgba(0, 0, 0, 0.04);

      .not-start-left {
        background: none;
      }

      .item-left {
        background-image: none;
      }
    }
  }
}

.score-bottom {
  font-weight: 500;
  font-size: 14px !important;
  color: #333333;
}

.zbbf {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  .zbbf-top {
    width: 2.25rem;
    font-size: 14px !important;
    color: #666666;
  }
}

.no-data-img {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 10px;
  img {
    width: 168px;
    height: 168px;
  }
  span {
    color: #909090;
    font-size: 14px;
    font-weight: 500;
  }
}

.no-play {
  border: 1px solid rgba(208, 45, 84, 1);
  color: rgba(208, 45, 84, 1) !important;
  background-color: #fff !important;
  &:hover {
    color: rgba(115, 0, 27, 1) !important;
  }
}
</style>
